import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiService } from '../../../api/apiClient';
import AuditFiltersBar from '../AuditFiltersBar';
import AuditTable, { statusPill, formatTs, monoShort, pre } from '../AuditTable';
import InfoBox from '../InfoBox';
import useAuditList from '../useAuditList';

export default function LLMCallsTab({ onOpenTrace }) {
  const { t } = useTranslation();
  const { rows, loading, filters, setFilters, offset, limit, next, prev } =
    useAuditList(apiService.listAuditLLM);

  const columns = [
    { key: 'timestamp', header: t('traceability:columns.timestamp'), render: (r) => formatTs(r.timestamp) },
    { key: 'phase', header: t('traceability:columns.phase') },
    { key: 'model', header: t('traceability:columns.model') },
    { key: 'tokens_in', header: t('traceability:columns.tokensIn') },
    { key: 'tokens_out', header: t('traceability:columns.tokensOut') },
    { key: 'latency_ms', header: t('traceability:columns.latency') },
    { key: 'status', header: t('traceability:columns.status'), render: (r) => statusPill(r.status) },
    { key: 'prompt_preview', header: 'Prompt',
      render: (r) => pre(r.prompt_preview, 160) },
    { key: 'response_preview', header: 'Response',
      render: (r) => pre(r.response_preview, 160) },
    { key: 'trace_id', header: t('traceability:columns.traceId'),
      render: (r) => <button onClick={(e) => { e.stopPropagation(); onOpenTrace(r.trace_id); }}
                             className="hover:text-accent-text">{monoShort(r.trace_id, 10)}</button> },
  ];

  return (
    <div>
      <InfoBox tabKey="llm" />
      <AuditFiltersBar value={filters} onChange={setFilters} />
      <AuditTable rows={rows} columns={columns} loading={loading}
                  limit={limit} offset={offset} onNext={next} onPrev={prev}
                  onRowClick={(r) => onOpenTrace(r.trace_id)} />
    </div>
  );
}
